import { Controller } from 'stimulus';

/**
 * Reloads the frame this is attached to when a modal opened from inside it reports
 * a successful change, so a list stays in step with what the user did in the pop-up
 * over it. A plain dismissal — the X, escape, a backdrop click — changed nothing, so
 * it leaves the frame alone rather than reading as a page refresh.
 *
 * The listener is on the frame rather than the document because the element that
 * opened the modal is a descendant of the frame, and remote-modal dispatches
 * `amba:remote-modal.success` on that opener with `bubbles: true`.
 *
 * `frameElement.reload()` is a no-op when the frame's src is the URL it is already
 * on, so the src is cleared before being set — the same technique as
 * reload_frame_to_url. A frame rendered inline has no src of its own, and the
 * page's own URL is what its content came from.
 */
export default class extends Controller {
  connect() {
    this.element.addEventListener('amba:remote-modal.success', this.reload);
  }

  disconnect() {
    this.element.removeEventListener('amba:remote-modal.success', this.reload);
  }

  reload = () => {
    const src = this.element.src || window.location.href;

    this.element.src = null;
    this.element.src = src;
  };
}
